import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00208cb2")

_pushScopeId("data-v-00208cb2")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = { class: "page__content" }
const _hoisted_4 = { class: "admin__group admin--info scrollbar--invisible" }
const _hoisted_5 = { class: "admin__summary" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "item__title" }, "Administrateur", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "admin__logo" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-tool" })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "sidebar__content"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "sidebar__title" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-info-circled" }),
  /*#__PURE__*/_createVNode("span", null, "Sommaire")
], -1)
const _hoisted_10 = {
  key: 1,
  class: "sidebar__content"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "sidebar__title" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-archive" }),
  /*#__PURE__*/_createVNode("span", null, "Archives")
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "sidebar__title" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-camera" }),
  /*#__PURE__*/_createVNode("span", null, "Backups")
], -1)
const _hoisted_13 = { class: "admin__group admin--content" }
const _hoisted_14 = { class: "tabs" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "icon-role" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "tab__text" }, "Utilisateurs", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "icon-user-add" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "tab__text" }, "Requêtes", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "icon-database" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "tab__text" }, "Base de données", -1)
const _hoisted_21 = { class: "item admin--data scrollbar--invisible" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UserSummary = _resolveComponent("UserSummary")
  const _component_ArchiveList = _resolveComponent("ArchiveList")
  const _component_BackupList = _resolveComponent("BackupList")
  const _component_UserList = _resolveComponent("UserList")
  const _component_PendingUserList = _resolveComponent("PendingUserList")
  const _component_DatabaseLog = _resolveComponent("DatabaseLog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            (_ctx.tabSelected === _ctx.TAB_TYPES.USERS)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_UserSummary, {
                    class: "sidebar__summary",
                    showAdmin: true
                  })
                ]))
              : (_ctx.tabSelected === _ctx.TAB_TYPES.DB)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_ArchiveList, { class: "sidebar__summary sidebar__summary--archive" }),
                    _hoisted_12,
                    _createVNode(_component_BackupList, { class: "sidebar__summary" })
                  ]))
                : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("div", {
              class: ["item__title tab__item", {'tab__item--selected': _ctx.tabSelected === _ctx.TAB_TYPES.USERS}],
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleView(_ctx.TAB_TYPES.USERS)))
            }, [
              _hoisted_15,
              _hoisted_16
            ], 2),
            _createVNode("div", {
              class: ["item__title tab__item", {'tab__item--selected': _ctx.tabSelected === _ctx.TAB_TYPES.REQUESTS}],
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleView(_ctx.TAB_TYPES.REQUESTS)))
            }, [
              _hoisted_17,
              _hoisted_18
            ], 2),
            _createVNode("div", {
              class: ["item__title tab__item", {'tab__item--selected': _ctx.tabSelected === _ctx.TAB_TYPES.DB}],
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleView(_ctx.TAB_TYPES.DB)))
            }, [
              _hoisted_19,
              _hoisted_20
            ], 2)
          ]),
          _createVNode("div", _hoisted_21, [
            (_ctx.tabSelected === _ctx.TAB_TYPES.USERS)
              ? (_openBlock(), _createBlock(_component_UserList, { key: 0 }))
              : _createCommentVNode("", true),
            (_ctx.tabSelected === _ctx.TAB_TYPES.REQUESTS)
              ? (_openBlock(), _createBlock(_component_PendingUserList, { key: 1 }))
              : (_ctx.tabSelected === _ctx.TAB_TYPES.DB)
                ? (_openBlock(), _createBlock(_component_DatabaseLog, { key: 2 }))
                : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
})